// extracted by mini-css-extract-plugin
export default {"wrapper":"BackGrad_wrapper__9DVLr","canvas":"BackGrad_canvas__ZyekJ"};